import { createContext, useContext, useEffect, useMemo, useState } from "react";

const LANG_KEY = "yin_lang";

const dict = {
  pt: {
    nav: {
      inicio: "Início",
      quemSomos: "Quem Somos",
      servicos: "Serviços",
      testemunhos: "Testemunhos",
      contacto: "Contacto",
      whatsapp: "Falar no WhatsApp",
      langLabel: "Idioma",
    },
    hero: {
      eyebrow: "Desde 2011 em Tavira",
      titleLine1: "Cuidamos do seu movimento",
      titleLine2: "há mais de 15 anos.",
      subtitle:
        "Com ciência, experiência e dedicação, oferecemos acompanhamento clínico personalizado em Tavira.",
      ctaWhatsapp: "Falar no WhatsApp",
      ctaContact: "Entre em Contacto",
      ratingGoogle: "no Google",
      ratingReviews: "53 avaliações de pacientes",
      statSmall: "anos de experiência\nclínica em Tavira",
    },
    quemSomos: {
      eyebrow: "Quem Somos",
      headline1: "Mais do que uma clínica,",
      headline2Prefix: "um espaço de ",
      headline2Word: "cuidado",
      headline3: "pensado para si.",
      foundersLabel: "Fundadores Yin Motion",
      teamLabel: "Equipa Yin Motion",
      p1Start: "A ",
      p1Bold: "Yin Motion",
      p1Rest:
        " é uma clínica de referência em Tavira, dedicada à promoção da saúde, reabilitação e movimento consciente.",
      p2:
        "Há mais de 15 anos, acompanhamos cada pessoa com um compromisso claro: oferecer um cuidado próximo, baseado em conhecimento científico, experiência clínica e atenção verdadeiramente personalizada.",
      quote:
        "Cada pessoa é única — e os melhores resultados surgem quando ciência, experiência e cuidado humano caminham juntos.",
      stats: [
        { strong: "+15", rest: "anos de experiência" },
        { strong: "Referência", rest: "em Tavira" },
        { strong: "Equipa", rest: "multidisciplinar" },
      ],
    },
    servicos: {
      eyebrow: "Especialidades",
      titleTop: "Especialidades",
      titleBottom: "pensadas para si",
      intro1: "Cada pessoa é única, e o seu acompanhamento também deve ser.",
      intro2:
        "Conheça as nossas especialidades e descubra a abordagem mais adequada para si.",
      groupTratamentosTitle: "Tratamentos",
      groupTratamentosDesc:
        "Abordagens clínicas focadas na recuperação, alívio da dor e equilíbrio do corpo.",
      groupTreinoTitle: "Treino & Movimento",
      groupTreinoDesc:
        "Métodos de movimento pensados para fortalecer, prevenir e melhorar a sua condição física.",
      verMais: "Ver mais",
      fechar: "Fechar",
      contactCta: "Entre em contacto para agendar uma consulta ou esclarecer dúvidas.",
      faleConnosco: "Fale Connosco",
      items: {
        fisioterapia: {
          name: "Fisioterapia",
          description:
            "A fisioterapia atua na prevenção, tratamento e recuperação de dores e lesões musculares e articulares. É indicada para quem procura aliviar dor, recuperar movimentos ou melhorar a sua qualidade de vida através de um acompanhamento profissional e personalizado.",
          detailHref: "/fisioterapia",
          detailCta: "Saiba mais",
        },
        "pilates-mat": {
          name: "Pilates Clínico Mat",
          description:
            "O Pilates Clínico em solo foca no controlo do corpo, postura e fortalecimento muscular. É ideal para quem pretende reduzir dores, melhorar a mobilidade e ganhar consciência corporal de forma segura e orientada.",
          detailHref: "/pilates-clinico",
          detailCta: "Saiba mais",
        },
        "pilates-equipamentos": {
          name: "Pilates Clínico Equipamentos",
          description:
            "Realizado com equipamentos específicos, este método permite um trabalho mais preciso e adaptado a cada pessoa. Indicado para reabilitação, fortalecimento e melhoria da postura com acompanhamento individualizado.",
          detailHref: "/pilates-clinico",
          detailCta: "Saiba mais",
        },
        gyrotonic: {
          name: "Gyrotonic®",
          description:
            "O Gyrotonic trabalha o corpo através de movimentos circulares e fluidos, promovendo mobilidade, força e coordenação. É ideal para quem procura um treino completo, suave e eficaz, respeitando os limites do corpo.",
          detailHref: "/gyrotonic",
          detailCta: "Saiba mais",
        },
        "power-plate": {
          name: "Power Plate",
          description:
            "O Power Plate utiliza vibrações mecânicas para ativar os músculos de forma rápida e eficaz. Indicado para quem pretende melhorar a força, circulação e recuperação física em sessões curtas e eficazes.",
          detailHref: "/power-plate",
          detailCta: "Saiba mais",
        },
        "terapia-fala": {
          name: "Terapia da Fala",
          description:
            "A Terapia da Fala atua na comunicação, linguagem, voz e deglutição. É indicada tanto para crianças como adultos que apresentam dificuldades na fala, compreensão ou expressão.",
          detailHref: "/terapia-fala",
          detailCta: "Saiba mais",
        },
        psicologia: {
          name: "Psicologia",
          description:
            "A psicologia ajuda a compreender e lidar com emoções, pensamentos e comportamentos. É indicada para quem procura equilíbrio emocional, autoconhecimento e apoio em momentos de maior desafio.",
          detailHref: "/psicologia",
          detailCta: "Saiba mais",
        },
        "medicina-chinesa": {
          name: "Medicina Chinesa",
          description:
            "Baseada numa abordagem holística, a Medicina Chinesa procura equilibrar o corpo e a mente através de técnicas como a acupuntura. Indicada para diversas condições, desde dor até questões emocionais.",
          detailHref: "/medicina-chinesa",
          detailCta: "Saiba mais",
        },
        osteopatia: {
          name: "Osteopatia",
          description:
            "A osteopatia utiliza técnicas manuais para identificar e tratar disfunções do corpo. É indicada para aliviar dores, melhorar a mobilidade e promover o equilíbrio geral do organismo.",
          detailHref: "/osteopatia",
          detailCta: "Saiba mais",
        },
        "treino-clinico": {
          name: "Treino Clínico Personalizado",
          description:
            "O treino clínico personalizado é adaptado às necessidades de cada pessoa, combinando exercício físico com acompanhamento profissional. Indicado para reabilitação, prevenção de lesões e melhoria da condição física.",
          detailHref: "/treino-clinico",
          detailCta: "Saiba mais",
        },
      },
    },
    porque: {
      eyebrow: "O nosso diferencial",
      titleStart: "Porque escolher a ",
      titleBrand: "Yin Motion",
      lead:
        "Uma abordagem verdadeiramente individual, com base científica, experiência clínica e um cuidado centrado em cada pessoa.",
      body:
        "Na Yin Motion, cada intervenção é pensada de forma única, combinamos conhecimento técnico, experiência e uma visão integrada do corpo para garantir resultados consistentes, seguros e duradouros.",
      pillars: [
        {
          num: "01",
          title: "Atendimento verdadeiramente individual",
          text: "Cada plano é adaptado à história, necessidades e objetivos de cada pessoa.",
        },
        {
          num: "02",
          title: "Planos personalizados e acompanhados",
          text: "Evolução contínua com ajustes conforme progresso clínico.",
        },
        {
          num: "03",
          title: "Base científica e prática clínica",
          text: "Intervenções sustentadas em evidência e experiência real.",
        },
        {
          num: "04",
          title: "Abordagem integrada do corpo",
          text: "O corpo é tratado como um todo, não apenas o sintoma.",
        },
        {
          num: "05",
          title: "Equipa qualificada e multidisciplinar",
          text: "Profissionais especializados em diferentes áreas da saúde.",
        },
        {
          num: "06",
          title: "Ambiente profissional, seguro e acolhedor",
          text: "Um espaço pensado para confiança, conforto e bem-estar.",
        },
      ],
      ctaEyebrow: "Fale connosco",
      ctaButton: "Falar com a equipa",
    },
    testemunhos: {
      eyebrow: "Testemunhos",
      titleLine1: "Histórias reais",
      titleLine2: "de quem confiou",
      titleLine3Start: "o seu corpo à ",
      titleLine3Brand: "Yin Motion",
      items: [
        {
          quote:
            "Depois de quase 6 anos, recuperei parte do que tinha perdido. Pouco a pouco, voltei a ter mobilidade novamente.",
          author: "José Ferreira",
          role: "Paciente",
        },
        {
          quote:
            "Ser paciente há mais de 10 anos já diz tudo. Rigor e competência constantes.",
          author: "Celeste Vilão",
          role: "Paciente de longa data",
        },
        {
          quote:
            "Very professional and friendly. I felt reassured throughout my knee recovery.",
          author: "Alison Watts",
          role: "Paciente",
        },
      ],
      starsAria: "5 estrelas",
      socialPrefix: "Mais de ",
      socialReviews: "50 avaliações",
      socialMiddle: " no Google com classificação média de ",
      socialStars: "5 estrelas",
      socialEnd: ".",
    },
    contacto: {
      eyebrow: "Contacto",
      titleBefore: "Comece hoje o seu processo de ",
      titleWord: "recuperação",
      titleAfter: ".",
      lead:
        "Entre em contacto connosco e descubra o melhor acompanhamento para si.",
      labels: {
        morada: "Morada",
        telefone: "Telefone",
        email: "Email",
        horario: "Horário",
      },
      whatsappPrompt: "Prefere falar por WhatsApp? Escreva-nos agora",
      mapTitle: "Mapa Yin Motion",
      formTitle: "Envie-nos uma mensagem",
      formSubtitle: "Preencha nosso formulário, entraremos em contacto em breve.",
      form: {
        name: "Nome completo",
        namePH: "O seu nome",
        email: "Email",
        emailPH: "nome@exemplo.com",
        phone: "Telefone",
        phonePH: "+351 ...",
        service: "Serviço pretendido",
        servicePH: "Escolher especialidade...",
        submit: "Enviar Mensagem",
        submitting: "A enviar...",
        consent: "Ao enviar, concorda em ser contactado pela equipa Yin Motion.",
        errRequired: "Por favor preencha todos os campos.",
        success: "Mensagem enviada. Entraremos em contacto em breve.",
        errDefault: "Não foi possível enviar. Tente novamente.",
        msgPrefix: "Pedido de contacto — ",
      },
      hours: [
        { day: "Segunda – Sexta", time: "09:00 – 19:00" },
        { day: "Sábado e Domingo", time: "Encerrado" },
      ],
      serviceOptions: [
        "Fisioterapia",
        "Pilates Clínico",
        "Gyrotonic®",
        "Power Plate",
        "Treino Clínico",
        "Osteopatia",
        "Terapia da Fala",
        "Psicologia",
        "Medicina Tradicional Chinesa",
        "Outro / Não sei ainda",
      ],
    },
    footer: {
      tagline: "Saúde e movimento clínico em Tavira desde {{year}}.",
      navHeading: "Navegação",
      servicesHeading: "Serviços",
      contactHeading: "Contacto",
      services: ["Fisioterapia", "Pilates Clínico", "Gyrotonic®", "Osteopatia"],
      whatsappBtn: "Falar no WhatsApp",
      rights: "Yin Motion — Saúde e Bem-Estar. Todos os direitos reservados.",
      location: "Tavira · Algarve · Portugal",
      signature: "by B4 Digital",
    },
    fisioPage: {
      back: "← Voltar",
      eyebrow: "Fisioterapia",
      heroTitle: "Fisioterapia com base científica e acompanhamento personalizado.",
      introEyebrow: "Introdução",
      introBody:
        "Na Yin Motion, a fisioterapia vai além do tratamento de sintomas. Cada pessoa é avaliada de forma completa, permitindo uma intervenção ajustada à sua realidade, com foco na recuperação eficaz e duradoura.",
      howEyebrow: "Como trabalhamos",
      howTitle: "A nossa abordagem",
      howLead:
        "A nossa abordagem distingue-se pela atenção ao detalhe, qualidade do acompanhamento e compromisso com resultados reais.",
      howItems: [
        "Atendimento individual — trabalhamos apenas com um paciente de cada vez",
        "Avaliação completa e intervenção personalizada",
        "Abordagem global, não limitada a uma única especialidade",
        "Formação contínua e prática baseada em evidência científica",
      ],
      techEyebrow: "Tecnologias e equipamentos",
      techTitle: "Tecnologia ao serviço da recuperação",
      techLead:
        "Dispomos de um conjunto de tecnologias que complementam o tratamento e potenciam os resultados. Cada recurso é utilizado de forma estratégica, de acordo com a necessidade de cada paciente.",
      techItems: [
        {
          name: "Ultra-sons",
          image:
            "https://customer-assets-0z36b82j.emergentagent.net/job_movimento-saude-1/artifacts/h12px23m_ultra-sons.jpeg",
          imagePosition: "center 40%",
        },
        {
          name: "Laser",
          image:
            "https://customer-assets-0z36b82j.emergentagent.net/job_movimento-saude-1/artifacts/mi25ynqq_laserrr.jpeg",
          imagePosition: "center 40%",
        },
        {
          name: "Eletroestimulação",
          image:
            "https://customer-assets-0z36b82j.emergentagent.net/job_movimento-saude-1/artifacts/ay39eght_WWSS.jpeg",
          imagePosition: "45% 55%",
        },
        {
          name: "Tecarterapia",
          image:
            "https://customer-assets-0z36b82j.emergentagent.net/job_movimento-saude-1/artifacts/j36quoig_TECAR.jpeg",
          imagePosition: "45% 48%",
        },
        {
          name: "Ondas de choque",
          image:
            "https://customer-assets-0z36b82j.emergentagent.net/job_movimento-saude-1/artifacts/pkp1v3yz_ondas%20de%20choque%20.jpeg",
          imagePosition: "62% 45%",
        },
        {
          name: "Magnetoterapia",
          image:
            "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/gjc3cjj9_Magnetoterapia.jpg",
          imagePosition: "55% 55%",
        },
        {
          name: "Pressoterapia",
          image:
            "https://customer-assets-0z36b82j.emergentagent.net/job_movimento-saude-1/artifacts/pyjm4sqo_pressoterapia.jpeg",
          imagePosition: "center 35%",
        },
        {
          name: "EPI — Eletrólise Percutânea Intratecidular",
          image:
            "https://customer-assets-0z36b82j.emergentagent.net/job_movimento-saude-1/artifacts/x878lalv_EPII.jpeg",
          imagePosition: "50% 38%",
        },
      ],
      gymEyebrow: "Reabilitação e movimento",
      gymTitle: "Ginásio de reabilitação",
      gymLead:
        "A recuperação não se limita ao tratamento passivo. Por isso, contamos com um ginásio de reabilitação totalmente equipado, que permite integrar o movimento no processo de recuperação.",
      gymItems: [
        {
          name: "Equipamentos de Pilates Clínico",
          icon: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/e9ceo71l_Pilates%20Cl%C3%ADnico%20Equipamentos.svg",
          href: "/pilates-clinico",
        },
        { name: "Gyrotonic®", icon: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/4c66ig6i_Gyrotonic.svg", href: "/gyrotonic" },
        { name: "Power Plate", icon: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/b42epm7p_Power%20Plate.svg", href: "/power-plate" },
        { name: "Passadeira", icon: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/mpbjtsqb_Passadeira.svg" },
        { name: "Bicicleta estática", icon: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/qvnydssa_Bicicleta%20est%C3%A1tica.svg" },
        { name: "Elíptica", icon: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/6nv6ui6x_El%C3%ADptica.svg" },
        { name: "Polias e acessórios funcionais", icon: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/q4wa7clj_Polias%20e%20acess%C3%B3rios%20funcionais.svg" },
      ],
      commitEyebrow: "O nosso compromisso",
      commitTitle: "O nosso compromisso é claro",
      commitLead:
        "Proporcionar a melhor recuperação possível, com segurança, eficácia e acompanhamento próximo. Trabalhamos para que cada paciente não apenas recupere, mas volte a sentir confiança no seu corpo.",
      ctaEyebrow: "Fale connosco",
      ctaTitle:
        "Comece o seu processo de recuperação com acompanhamento profissional e personalizado.",
      ctaButton: "Fale Connosco",
    },
    pilatesPage: {
      back: "← Voltar",
      eyebrow: "Pilates Clínico",
      heroTitle: "Pilates Clínico com acompanhamento especializado.",
      introEyebrow: "Introdução",
      introHeadline: "Pilates Clínico em tapete e equipamentos.",
      introBody:
        "Na Yin Motion, o Pilates distingue-se pela sua forte vertente clínica, pela qualidade técnica e pela segurança do movimento. Cada sessão é pensada de forma individual, respeitando o corpo e os objetivos de cada pessoa.",
      howEyebrow: "Como trabalhamos",
      howTitle: "Acompanhamento clínico, sempre",
      howLead:
        "O nosso acompanhamento combina os princípios do Pilates com uma base clínica sólida, garantindo um trabalho seguro e eficaz.",
      howItems: [
        "Aulas em pequenos grupos e sessões individuais personalizadas",
        "Sempre orientadas por fisioterapeutas com formação certificada em Pilates Clínico",
        "Abordagem baseada nos princípios do Pilates clássico e clínico",
        "Exercícios adaptados às necessidades, limitações e objetivos de cada pessoa",
      ],
      equipEyebrow: "Equipamentos e métodos",
      equipTitle: "Grandes equipamentos de Pilates",
      equipLead:
        "Trabalhamos com grandes equipamentos de Pilates, que permitem um trabalho mais preciso, controlado e adaptado:",
      equipItems: [
        {
          name: "Reformer",
          image: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/xed80wl3_Reformer.jpg",
        },
        {
          name: "Cadillac",
          image: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/7w3ada4f_Cadillac.jpg",
        },
        {
          name: "Wunda Chair",
          image: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/f43u9snt_Wunda%20Chair.jpg",
        },
        {
          name: "Barrel",
          image: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/5twp15z8_Barrel.jpg",
        },
        {
          name: "Spine Corrector",
          image: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/zeoleyi1_Spine%20Corrector.jpg",
        },
      ],
      accessoriesLabel: "As sessões são complementadas com:",
      accessoriesItems: ["Tapete", "Elásticos", "Arcos", "Pesos", "Outros acessórios"],
      expEyebrow: "Experiência e diferenciação",
      expTitle: "Pioneiros em Tavira",
      expBody:
        "Em 2011, fomos pioneiros em Tavira no trabalho com Pilates em grandes equipamentos. Hoje, essa abordagem é amplamente utilizada na região — reflexo do impacto positivo do nosso trabalho ao longo dos anos.",
      expYear: "2011",
      expYearLabel: "Pioneiros em Tavira",
      indicationsEyebrow: "Para quem é indicado",
      indicationsTitle: "Indicado para si se procura",
      indications: [
        "Alívio de dores musculares e articulares",
        "Reabilitação e recuperação física",
        "Melhoria da postura",
        "Fortalecimento muscular",
        "Prevenção de lesões",
        "Aumento da mobilidade e controlo do corpo",
      ],
      goalEyebrow: "O nosso objetivo",
      goalTitle: "Movimento consciente, seguro e eficiente",
      goalBody:
        "Ajudar cada pessoa a desenvolver um movimento mais consciente, seguro e eficiente, promovendo bem-estar e qualidade de vida.",
      ctaEyebrow: "Fale connosco",
      ctaTitle:
        "Comece a cuidar do seu corpo com acompanhamento profissional e personalizado.",
      ctaButton: "Fale Connosco",
    },
    gyrotonicPage: {
      back: "← Voltar",
      eyebrow: "Gyrotonic®",
      heroTitle: "Movimento tridimensional com abordagem clínica.",
      introEyebrow: "Introdução",
      introBody:
        "O método Gyrotonic® é uma abordagem inovadora de movimento que trabalha o corpo de forma global, fluida e tridimensional. Respeitando a biomecânica natural e os princípios científicos do movimento humano, promove um trabalho completo e equilibrado.",
      howEyebrow: "Como funciona",
      howTitle: "Movimentos circulares, espirais e ondulatórios",
      howLead:
        "Baseado em movimentos circulares, espirais e ondulatórios, associados à respiração, o Gyrotonic® permite desenvolver o corpo de forma integrada e eficiente.",
      howSubhead: "Este método promove simultaneamente:",
      howItems: [
        "Mobilidade articular",
        "Força profunda",
        "Coordenação",
        "Consciência corporal",
        "Reeducação postural",
      ],
      applicationEyebrow: "Aplicação clínica e funcional",
      applicationTitle: "Amplamente utilizado em diferentes contextos",
      applicationItems: [
        "Reabilitação física",
        "Prevenção de lesões",
        "Melhoria da postura",
        "Treino de performance",
        "Aumento da mobilidade e controlo do corpo",
      ],
      expEyebrow: "Experiência e diferenciação",
      expTitle: "Pioneiros em Tavira",
      expBody1:
        "Na Yin Motion, fomos o primeiro espaço em Tavira a disponibilizar o método Gyrotonic®, integrando-o numa abordagem clínica, segura e personalizada.",
      expBody2:
        "Tal como aconteceu com o Pilates em 2011, o nosso trabalho contribuiu para a introdução e crescimento deste método na região.",
      expYearLabel: "Primeiros em Tavira",
      expHighlight: "1º",
      supportEyebrow: "Acompanhamento especializado",
      supportTitle: "Fisioterapeutas com formação certificada",
      supportBody:
        "Todas as sessões são orientadas por fisioterapeutas com formação específica certificada, garantindo segurança, eficácia e adaptação às necessidades de cada pessoa.",
      goalEyebrow: "O nosso objetivo",
      goalTitle: "Movimento mais livre, eficiente e consciente",
      goalBody:
        "Promover um movimento mais livre, eficiente e consciente, ajudando cada pessoa a melhorar a sua relação com o corpo e a sua qualidade de vida.",
      ctaEyebrow: "Fale connosco",
      ctaTitle:
        "Descubra um método diferente, completo e adaptado a si.",
      ctaButton: "Fale Connosco",
    },
    powerPlatePage: {
      back: "← Voltar",
      eyebrow: "Power Plate",
      heroTitle: "Estimulação neuromuscular com tecnologia avançada.",
      introEyebrow: "Introdução",
      introBody:
        "O treino com recurso à Power Plate baseia-se na vibração mecânica controlada, estimulando o sistema neuromuscular de forma eficaz e segura. Esta tecnologia permite potenciar os resultados do treino, adaptando-se às necessidades de cada pessoa.",
      howEyebrow: "Como funciona",
      howTitle: "Vibração controlada, ativação profunda",
      howLead:
        "A vibração gerada pela Power Plate ativa a musculatura de forma mais intensa e profunda, promovendo um trabalho completo em menos tempo.",
      howSubhead: "Este método contribui para:",
      howItems: [
        "Ativação muscular profunda",
        "Ganho de força e resistência",
        "Melhoria da estabilidade e equilíbrio",
        "Aumento da densidade óssea",
        "Otimização do tempo de treino",
      ],
      applicationEyebrow: "Aplicação no treino e reabilitação",
      applicationTitle: "Integrada em diferentes contextos",
      applicationItems: [
        "Reabilitação física",
        "Treino funcional",
        "Prevenção de lesões",
        "Recuperação muscular",
        "Melhoria da condição física geral",
      ],
      supportEyebrow: "Acompanhamento especializado",
      supportTitle: "Sempre orientado por profissionais qualificados",
      supportBody:
        "Na Yin Motion, o treino com Power Plate é sempre orientado por profissionais qualificados, garantindo segurança, eficácia e adaptação ao nível de cada pessoa.",
      goalEyebrow: "O nosso objetivo",
      goalTitle: "Treino mais eficiente, inteligente e adaptado",
      goalBody:
        "Proporcionar um treino mais eficiente, inteligente e adaptado, ajudando cada pessoa a evoluir com segurança e resultados consistentes.",
      ctaEyebrow: "Fale connosco",
      ctaTitle: "Experimente uma abordagem de treino mais eficaz e orientada.",
      ctaButton: "Fale Connosco",
    },
    treinoPage: {
      back: "← Voltar",
      eyebrow: "Treino Clínico Personalizado",
      heroTitle: "Uma abordagem global ao movimento.",
      introEyebrow: "Introdução",
      introBody1:
        "No treino clínico personalizado, não nos limitamos a um método específico. Integramos aquilo que consideramos mais eficaz para cada caso, combinando o conhecimento da fisioterapia com diferentes técnicas e ferramentas.",
      introBody2:
        "Cada plano é pensado de forma individual, respeitando o corpo, os objetivos e o contexto de cada pessoa.",
      howEyebrow: "Como trabalhamos",
      howTitle: "Visão global do movimento",
      howLead:
        "A nossa abordagem baseia-se numa visão global do movimento, permitindo um trabalho completo, seguro e progressivo.",
      howItems: [
        "Melhoria da mobilidade, postura e equilíbrio",
        "Aumento da força e resistência",
        "Prevenção de lesões",
        "Recuperação funcional",
        "Desenvolvimento da performance física",
        "Promoção do bem-estar global",
      ],
      integratedEyebrow: "Uma abordagem integrada",
      integratedTitle: "Adaptação contínua à sua evolução",
      integratedBody1:
        "Ao contrário de um treino convencional, o treino clínico personalizado adapta-se continuamente à evolução de cada pessoa.",
      integratedBody2:
        "Integramos diferentes métodos e ferramentas, selecionando sempre aquilo que faz mais sentido para o seu caso específico.",
      supportEyebrow: "Acompanhamento especializado",
      supportTitle: "Conhecimento aprofundado do corpo e do movimento",
      supportLead:
        "Toda a intervenção é orientada com base no conhecimento aprofundado do corpo, do movimento e dos processos de reabilitação.",
      supportSubhead: "Garantimos um acompanhamento:",
      supportItems: ["Seguro", "Consciente", "Personalizado", "Focado em resultados sustentáveis"],
      goalEyebrow: "O nosso objetivo",
      goalTitle: "Evoluir de forma consistente",
      goalBody:
        "Ajudar cada pessoa a evoluir de forma consistente, recuperando confiança no corpo e melhorando a sua qualidade de vida através do movimento.",
      ctaEyebrow: "Fale connosco",
      ctaTitle: "Comece um treino adaptado a si, com acompanhamento profissional.",
      ctaButton: "Fale Connosco",
    },
    osteopatiaPage: {
      back: "← Voltar",
      eyebrow: "Osteopatia",
      heroTitle: "Terapia manual para equilíbrio e mobilidade do corpo.",
      introEyebrow: "Introdução",
      introBody:
        "A Osteopatia é uma terapia manual que atua sobre disfunções musculoesqueléticas e funcionais, promovendo o equilíbrio global do organismo.",
      howEyebrow: "Como funciona",
      howTitle: "Identificar a causa, não apenas os sintomas",
      howBody:
        "Através de técnicas manuais específicas, a osteopatia procura identificar a causa do problema, não apenas os sintomas.",
      benefitsEyebrow: "Benefícios",
      benefitsTitle: "A Osteopatia contribui para:",
      benefitsItems: [
        "Redução da dor",
        "Melhoria da mobilidade",
        "Equilíbrio do corpo",
        "Recuperação funcional",
      ],
      globalEyebrow: "Abordagem global",
      globalTitle: "O corpo como um todo",
      globalBody:
        "O tratamento é feito de forma integrada, considerando o corpo como um todo e respeitando a individualidade de cada pessoa.",
      goalEyebrow: "O nosso objetivo",
      goalTitle: "Equilíbrio, bem-estar e funcionalidade",
      goalBody:
        "Promover o equilíbrio do organismo, ajudando cada pessoa a recuperar o seu bem-estar e funcionalidade.",
      ctaEyebrow: "Fale connosco",
      ctaTitle: "Recupere o equilíbrio do seu corpo com acompanhamento especializado.",
      ctaButton: "Fale Connosco",
    },
    medicinaChinesaPage: {
      back: "← Voltar",
      eyebrow: "Medicina Tradicional Chinesa",
      heroTitle: "Medicina Tradicional Chinesa — equilíbrio e bem-estar de forma integrada.",
      introEyebrow: "Introdução",
      introBody:
        "A Medicina Tradicional Chinesa é uma abordagem terapêutica que procura restabelecer o equilíbrio do organismo. Atua de forma integrada, considerando o corpo como um todo.",
      howEyebrow: "Como funciona",
      howTitle: "Princípios milenares, visão global",
      howBody:
        "Baseia-se em princípios milenares aliados a uma visão global do organismo, promovendo o equilíbrio físico e emocional.",
      indicationsEyebrow: "Indicações",
      indicationsTitle: "Esta abordagem é eficaz na gestão de:",
      indicationsItems: [
        "Dor",
        "Stress",
        "Fadiga",
        "Disfunções funcionais",
        "Desequilíbrios do organismo",
      ],
      complementaryEyebrow: "Abordagem complementar",
      complementaryTitle: "Complementa os cuidados convencionais",
      complementaryBody:
        "A Medicina Tradicional Chinesa complementa os cuidados convencionais, potenciando resultados e promovendo bem-estar global.",
      goalEyebrow: "O nosso objetivo",
      goalTitle: "Equilíbrio do corpo e da mente",
      goalBody:
        "Restabelecer o equilíbrio do corpo e da mente, contribuindo para uma melhor qualidade de vida.",
      ctaEyebrow: "Fale connosco",
      ctaTitle: "Descubra uma abordagem complementar focada no seu bem-estar.",
      ctaButton: "Fale Connosco",
    },
    terapiaFalaPage: {
      back: "← Voltar",
      eyebrow: "Terapia da Fala",
      heroTitle: "Terapia da Fala — comunicação, linguagem e função com acompanhamento especializado.",
      introEyebrow: "Introdução",
      introBody:
        "A Terapia da Fala atua na avaliação e tratamento de perturbações da comunicação, linguagem, fala, voz e deglutição. Na Yin Motion, o acompanhamento é feito com rigor clínico e adaptado a cada pessoa.",
      approachEyebrow: "Como trabalhamos",
      approachTitle: "Intervenção individual, rigorosa e contínua",
      approachLead:
        "A intervenção é orientada de forma individual, respeitando as necessidades específicas de cada caso.",
      approachItems: [
        "Avaliação completa e personalizada",
        "Intervenção adaptada a crianças e adultos",
        "Trabalho contínuo e progressivo",
        "Foco na melhoria funcional e na qualidade de vida",
      ],
      areasEyebrow: "Áreas de intervenção",
      areasTitle: "A Terapia da Fala pode ajudar em:",
      areasItems: [
        "Dificuldades na fala e linguagem",
        "Perturbações da comunicação",
        "Alterações da voz",
        "Dificuldades de deglutição",
        "Desenvolvimento da comunicação em crianças",
      ],
      trustEyebrow: "Acompanhamento especializado",
      trustTitle: "Experiência clínica e rigor profissional",
      trustBody:
        "O acompanhamento é realizado com elevada experiência clínica e rigor profissional, garantindo um processo seguro, estruturado e eficaz.",
      goalEyebrow: "O nosso objetivo",
      goalTitle: "Comunicar com clareza, confiança e funcionalidade",
      goalBody:
        "Ajudar cada pessoa a comunicar com mais clareza, confiança e funcionalidade no seu dia a dia.",
      ctaEyebrow: "Fale connosco",
      ctaTitle: "Fale connosco para iniciar um acompanhamento adaptado às suas necessidades.",
      ctaButton: "Fale Connosco",
    },
    psicologiaPage: {
      back: "← Voltar",
      eyebrow: "Psicologia",
      heroTitle: "Apoio emocional com acompanhamento profissional e confidencial.",
      introEyebrow: "Introdução",
      introBody:
        "A psicologia na Yin Motion é orientada para a promoção da saúde mental e equilíbrio emocional. Cada acompanhamento é feito com respeito, confidencialidade e atenção individual.",
      howEyebrow: "Como trabalhamos",
      howTitle: "Adaptado à sua realidade",
      howBody:
        "O apoio psicológico é adaptado à realidade de cada pessoa, promovendo compreensão, equilíbrio e desenvolvimento pessoal.",
      areasEyebrow: "Áreas de intervenção",
      areasTitle: "A psicologia pode ajudar em:",
      areasItems: [
        "Ansiedade e stress",
        "Gestão emocional",
        "Dor crónica",
        "Adaptação a diferentes fases da vida",
        "Desenvolvimento pessoal",
      ],
      trustEyebrow: "Confidencialidade e confiança",
      trustTitle: "Um espaço seguro, só seu",
      trustBody:
        "Garantimos um espaço seguro, onde cada pessoa pode expressar-se livremente, com total respeito e profissionalismo.",
      goalEyebrow: "O nosso objetivo",
      goalTitle: "Equilíbrio emocional, clareza e bem-estar",
      goalBody:
        "Ajudar cada pessoa a encontrar equilíbrio emocional, clareza e bem-estar no seu dia a dia.",
      ctaEyebrow: "Fale connosco",
      ctaTitle: "Dê o primeiro passo para cuidar da sua saúde mental.",
      ctaButton: "Fale Connosco",
    },
  },

  en: {
    nav: {
      inicio: "Home",
      quemSomos: "About Us",
      servicos: "Services",
      testemunhos: "Testimonials",
      contacto: "Contact",
      whatsapp: "Message us on WhatsApp",
      langLabel: "Language",
    },
    hero: {
      eyebrow: "In Tavira since 2011",
      titleLine1: "Caring for your movement",
      titleLine2: "for over 15 years.",
      subtitle:
        "With science, experience and dedication, we offer personalised clinical care in Tavira.",
      ctaWhatsapp: "Message us on WhatsApp",
      ctaContact: "Get in Touch",
      ratingGoogle: "on Google",
      ratingReviews: "53 patient reviews",
      statSmall: "years of clinical\nexperience in Tavira",
    },
    quemSomos: {
      eyebrow: "About Us",
      headline1: "More than a clinic,",
      headline2Prefix: "a space of ",
      headline2Word: "care",
      headline3: "designed for you.",
      foundersLabel: "Yin Motion Founders",
      teamLabel: "Yin Motion Team",
      p1Start: "",
      p1Bold: "Yin Motion",
      p1Rest:
        " is a leading clinic in Tavira, dedicated to promoting health, rehabilitation and mindful movement.",
      p2:
        "For over 15 years, we have supported each person with a clear commitment: to provide attentive, personalised care grounded in scientific knowledge and clinical experience.",
      quote:
        "Every person is unique — and the best results come when science, experience and genuine human care work together.",
      stats: [
        { strong: "15+", rest: "years of experience" },
        { strong: "Trusted", rest: "in Tavira" },
        { strong: "Multidisciplinary", rest: "team" },
      ],
    },
    servicos: {
      eyebrow: "Specialities",
      titleTop: "Specialities",
      titleBottom: "designed for you",
      intro1: "Every person is unique, and so should be their care.",
      intro2:
        "Discover our specialities and find the approach best suited to you.",
      groupTratamentosTitle: "Treatments",
      groupTratamentosDesc:
        "Clinical approaches focused on recovery, pain relief and bodily balance.",
      groupTreinoTitle: "Training & Movement",
      groupTreinoDesc:
        "Movement methods designed to strengthen, prevent and improve your physical condition.",
      verMais: "Read more",
      fechar: "Close",
      contactCta:
        "Get in touch to book an appointment or ask any questions.",
      faleConnosco: "Get in Touch",
      items: {
        fisioterapia: {
          name: "Physiotherapy",
          description:
            "Physiotherapy focuses on the prevention, treatment and recovery of muscular and joint pain and injuries. It is ideal for those seeking pain relief, restored movement or an improved quality of life through personalised, professional care.",
          detailHref: "/fisioterapia",
          detailCta: "Learn more",
        },
        "pilates-mat": {
          name: "Clinical Pilates — Mat",
          description:
            "Mat-based Clinical Pilates focuses on body control, posture and muscular strength. It is ideal for reducing pain, improving mobility and building body awareness in a safe and guided way.",
          detailHref: "/pilates-clinico",
          detailCta: "Learn more",
        },
        "pilates-equipamentos": {
          name: "Clinical Pilates — Equipment",
          description:
            "Performed with specialised equipment, this method allows for precise work tailored to each person. Suitable for rehabilitation, strengthening and postural improvement with individualised support.",
          detailHref: "/pilates-clinico",
          detailCta: "Learn more",
        },
        gyrotonic: {
          name: "Gyrotonic®",
          description:
            "Gyrotonic works the body through circular, flowing movements, enhancing mobility, strength and coordination. Ideal for those seeking a complete yet gentle practice that respects the body’s limits.",
          detailHref: "/gyrotonic",
          detailCta: "Learn more",
        },
        "power-plate": {
          name: "Power Plate",
          description:
            "Power Plate uses mechanical vibrations to activate muscles quickly and effectively. Recommended for improving strength, circulation and physical recovery in short, efficient sessions.",
          detailHref: "/power-plate",
          detailCta: "Learn more",
        },
        "terapia-fala": {
          name: "Speech Therapy",
          description:
            "Speech Therapy supports communication, language, voice and swallowing. It is recommended for children and adults who experience difficulties with speech, comprehension or expression.",
          detailHref: "/terapia-fala",
          detailCta: "Learn more",
        },
        psicologia: {
          name: "Psychology",
          description:
            "Psychology helps you understand and navigate emotions, thoughts and behaviour. Ideal for those seeking emotional balance, self-awareness and support during challenging moments.",
          detailHref: "/psicologia",
          detailCta: "Learn more",
        },
        "medicina-chinesa": {
          name: "Chinese Medicine",
          description:
            "Based on a holistic approach, Chinese Medicine seeks to balance body and mind through techniques such as acupuncture. Suitable for a variety of conditions, from pain to emotional wellbeing.",
          detailHref: "/medicina-chinesa",
          detailCta: "Learn more",
        },
        osteopatia: {
          name: "Osteopathy",
          description:
            "Osteopathy uses manual techniques to identify and treat bodily dysfunctions. Recommended to ease pain, improve mobility and promote overall balance.",
          detailHref: "/osteopatia",
          detailCta: "Learn more",
        },
        "treino-clinico": {
          name: "Personalised Clinical Training",
          description:
            "Personalised clinical training is tailored to each person’s needs, combining physical exercise with professional support. Ideal for rehabilitation, injury prevention and improved physical condition.",
          detailHref: "/treino-clinico",
          detailCta: "Learn more",
        },
      },
    },
    porque: {
      eyebrow: "What sets us apart",
      titleStart: "Why choose ",
      titleBrand: "Yin Motion",
      lead:
        "A genuinely individual approach, grounded in science, clinical experience and care centred on each person.",
      body:
        "At Yin Motion, every intervention is thought out uniquely — we bring together technical knowledge, experience and an integrated view of the body to deliver consistent, safe and lasting results.",
      pillars: [
        {
          num: "01",
          title: "Truly individual care",
          text: "Each plan is tailored to the history, needs and goals of every person.",
        },
        {
          num: "02",
          title: "Personalised, supported plans",
          text: "Continuous progress with adjustments according to clinical development.",
        },
        {
          num: "03",
          title: "Scientific basis and clinical practice",
          text: "Interventions grounded in evidence and real-world experience.",
        },
        {
          num: "04",
          title: "Integrated view of the body",
          text: "We treat the body as a whole, not just the symptom.",
        },
        {
          num: "05",
          title: "Qualified, multidisciplinary team",
          text: "Professionals specialised in different areas of health.",
        },
        {
          num: "06",
          title: "Professional, safe and welcoming setting",
          text: "A space designed for trust, comfort and wellbeing.",
        },
      ],
      ctaEyebrow: "Get in touch",
      ctaButton: "Speak to the team",
    },
    testemunhos: {
      eyebrow: "Testimonials",
      titleLine1: "Real stories",
      titleLine2: "from those who trusted",
      titleLine3Start: "their body to ",
      titleLine3Brand: "Yin Motion",
      items: [
        {
          quote:
            "After almost 6 years, I recovered part of what I had lost. Little by little, I regained my mobility.",
          author: "José Ferreira",
          role: "Patient",
        },
        {
          quote:
            "Being a patient for over 10 years says it all. Consistent rigour and expertise.",
          author: "Celeste Vilão",
          role: "Long-standing patient",
        },
        {
          quote:
            "Very professional and friendly. I felt reassured throughout my knee recovery.",
          author: "Alison Watts",
          role: "Patient",
        },
      ],
      starsAria: "5 stars",
      socialPrefix: "Over ",
      socialReviews: "50 reviews",
      socialMiddle: " on Google with an average rating of ",
      socialStars: "5 stars",
      socialEnd: ".",
    },
    contacto: {
      eyebrow: "Contact",
      titleBefore: "Begin your ",
      titleWord: "recovery",
      titleAfter: " journey today.",
      lead:
        "Get in touch and discover the best approach for you.",
      labels: {
        morada: "Address",
        telefone: "Phone",
        email: "Email",
        horario: "Opening Hours",
      },
      whatsappPrompt: "Prefer WhatsApp? Message us now",
      mapTitle: "Yin Motion Map",
      formTitle: "Send us a message",
      formSubtitle: "Fill in our form and we will be in touch shortly.",
      form: {
        name: "Full Name",
        namePH: "Your name",
        email: "Email",
        emailPH: "name@example.com",
        phone: "Phone",
        phonePH: "+351 ...",
        service: "Select a Service",
        servicePH: "Choose a speciality...",
        submit: "Send Message",
        submitting: "Sending...",
        consent: "By submitting, you agree to be contacted by the Yin Motion team.",
        errRequired: "Please fill in all the fields.",
        success: "Message sent. We will be in touch shortly.",
        errDefault: "We could not send your message. Please try again.",
        msgPrefix: "Enquiry — ",
      },
      hours: [
        { day: "Monday – Friday", time: "09:00 – 19:00" },
        { day: "Saturday & Sunday", time: "Closed" },
      ],
      serviceOptions: [
        "Physiotherapy",
        "Clinical Pilates",
        "Gyrotonic®",
        "Power Plate",
        "Clinical Training",
        "Osteopathy",
        "Speech Therapy",
        "Psychology",
        "Traditional Chinese Medicine",
        "Other / Not sure yet",
      ],
    },
    footer: {
      tagline: "Clinical health and movement in Tavira since {{year}}.",
      navHeading: "Navigation",
      servicesHeading: "Services",
      contactHeading: "Contact",
      services: ["Physiotherapy", "Clinical Pilates", "Gyrotonic®", "Osteopathy"],
      whatsappBtn: "Message us on WhatsApp",
      rights: "Yin Motion — Health & Wellbeing. All rights reserved.",
      location: "Tavira · Algarve · Portugal",
      signature: "by B4 Digital",
    },
    fisioPage: {
      back: "← Back",
      eyebrow: "Physiotherapy",
      heroTitle: "Physiotherapy rooted in science, with personalised care.",
      introEyebrow: "Introduction",
      introBody:
        "At Yin Motion, physiotherapy goes far beyond treating symptoms. Each person undergoes a thorough assessment, allowing us to tailor every intervention to their reality, with a focus on effective, lasting recovery.",
      howEyebrow: "How we work",
      howTitle: "Our approach",
      howLead:
        "Our approach stands out for its attention to detail, the quality of our follow-up and a genuine commitment to real results.",
      howItems: [
        "One-to-one care — we work with a single patient at a time",
        "Thorough assessment and personalised intervention",
        "A whole-body approach, not limited to a single speciality",
        "Continuous training and evidence-based practice",
      ],
      techEyebrow: "Technology & equipment",
      techTitle: "Technology in service of recovery",
      techLead:
        "We have a range of technologies that complement treatment and enhance results. Each resource is used strategically, according to the needs of every patient.",
      techItems: [
        {
          name: "Ultrasound",
          image:
            "https://customer-assets-0z36b82j.emergentagent.net/job_movimento-saude-1/artifacts/h12px23m_ultra-sons.jpeg",
          imagePosition: "center 40%",
        },
        {
          name: "Laser",
          image:
            "https://customer-assets-0z36b82j.emergentagent.net/job_movimento-saude-1/artifacts/mi25ynqq_laserrr.jpeg",
          imagePosition: "center 40%",
        },
        {
          name: "Electrostimulation",
          image:
            "https://customer-assets-0z36b82j.emergentagent.net/job_movimento-saude-1/artifacts/ay39eght_WWSS.jpeg",
          imagePosition: "45% 55%",
        },
        {
          name: "Tecar therapy",
          image:
            "https://customer-assets-0z36b82j.emergentagent.net/job_movimento-saude-1/artifacts/j36quoig_TECAR.jpeg",
          imagePosition: "45% 48%",
        },
        {
          name: "Shockwave therapy",
          image:
            "https://customer-assets-0z36b82j.emergentagent.net/job_movimento-saude-1/artifacts/pkp1v3yz_ondas%20de%20choque%20.jpeg",
          imagePosition: "62% 45%",
        },
        {
          name: "Magnetotherapy",
          image:
            "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/gjc3cjj9_Magnetoterapia.jpg",
          imagePosition: "55% 55%",
        },
        {
          name: "Pressotherapy",
          image:
            "https://customer-assets-0z36b82j.emergentagent.net/job_movimento-saude-1/artifacts/pyjm4sqo_pressoterapia.jpeg",
          imagePosition: "center 35%",
        },
        {
          name: "EPI — Ultrasound-Guided Percutaneous Electrolysis",
          image:
            "https://customer-assets-0z36b82j.emergentagent.net/job_movimento-saude-1/artifacts/x878lalv_EPII.jpeg",
          imagePosition: "50% 38%",
        },
      ],
      gymEyebrow: "Rehabilitation & movement",
      gymTitle: "Rehabilitation gym",
      gymLead:
        "Recovery is not limited to passive treatment. That is why we have a fully equipped rehabilitation gym, allowing us to integrate movement into the recovery process.",
      gymItems: [
        {
          name: "Clinical Pilates equipment",
          icon: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/e9ceo71l_Pilates%20Cl%C3%ADnico%20Equipamentos.svg",
          href: "/pilates-clinico",
        },
        { name: "Gyrotonic®", icon: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/4c66ig6i_Gyrotonic.svg", href: "/gyrotonic" },
        { name: "Power Plate", icon: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/b42epm7p_Power%20Plate.svg", href: "/power-plate" },
        { name: "Treadmill", icon: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/mpbjtsqb_Passadeira.svg" },
        { name: "Stationary bike", icon: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/qvnydssa_Bicicleta%20est%C3%A1tica.svg" },
        { name: "Cross trainer", icon: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/6nv6ui6x_El%C3%ADptica.svg" },
        { name: "Pulleys and functional accessories", icon: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/q4wa7clj_Polias%20e%20acess%C3%B3rios%20funcionais.svg" },
      ],
      commitEyebrow: "Our commitment",
      commitTitle: "Our commitment is clear",
      commitLead:
        "To deliver the best possible recovery — safe, effective and with close, attentive support. We work so that every patient not only recovers, but regains confidence in their own body.",
      ctaEyebrow: "Get in touch",
      ctaTitle:
        "Begin your recovery with professional, personalised support.",
      ctaButton: "Get in Touch",
    },
    pilatesPage: {
      back: "← Back",
      eyebrow: "Clinical Pilates",
      heroTitle: "Clinical Pilates with specialist guidance.",
      introEyebrow: "Introduction",
      introHeadline: "Clinical Pilates on mat and equipment.",
      introBody:
        "At Yin Motion, Pilates stands out for its strong clinical foundation, technical quality and safety of movement. Each session is designed individually, respecting the body and goals of every person.",
      howEyebrow: "How we work",
      howTitle: "Clinical guidance, always",
      howLead:
        "Our approach blends the principles of Pilates with a solid clinical foundation, ensuring safe and effective work.",
      howItems: [
        "Small-group classes and personalised one-to-one sessions",
        "Always led by physiotherapists certified in Clinical Pilates",
        "An approach grounded in the principles of classical and clinical Pilates",
        "Exercises adapted to the needs, limitations and goals of each person",
      ],
      equipEyebrow: "Equipment & methods",
      equipTitle: "Full-size Pilates equipment",
      equipLead:
        "We work with full-size Pilates equipment, allowing for more precise, controlled and tailored work:",
      equipItems: [
        {
          name: "Reformer",
          image: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/xed80wl3_Reformer.jpg",
        },
        {
          name: "Cadillac",
          image: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/7w3ada4f_Cadillac.jpg",
        },
        {
          name: "Wunda Chair",
          image: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/f43u9snt_Wunda%20Chair.jpg",
        },
        {
          name: "Barrel",
          image: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/5twp15z8_Barrel.jpg",
        },
        {
          name: "Spine Corrector",
          image: "https://customer-assets.emergentagent.com/job_movimento-saude-1/artifacts/zeoleyi1_Spine%20Corrector.jpg",
        },
      ],
      accessoriesLabel: "Sessions are complemented with:",
      accessoriesItems: ["Mat", "Resistance bands", "Arcs", "Weights", "Other accessories"],
      expEyebrow: "Experience & distinction",
      expTitle: "Pioneers in Tavira",
      expBody:
        "In 2011, we were pioneers in Tavira in working with full-size Pilates equipment. Today, this approach is widely used across the region — a reflection of the positive impact of our work over the years.",
      expYear: "2011",
      expYearLabel: "Pioneers in Tavira",
      indicationsEyebrow: "Who it is for",
      indicationsTitle: "Ideal for you if you are looking for",
      indications: [
        "Relief of muscular and joint pain",
        "Rehabilitation and physical recovery",
        "Improved posture",
        "Muscular strengthening",
        "Injury prevention",
        "Greater mobility and body control",
      ],
      goalEyebrow: "Our goal",
      goalTitle: "Mindful, safe and efficient movement",
      goalBody:
        "To help every person develop more mindful, safe and efficient movement, promoting wellbeing and quality of life.",
      ctaEyebrow: "Get in touch",
      ctaTitle:
        "Start caring for your body with professional, personalised support.",
      ctaButton: "Get in Touch",
    },
    gyrotonicPage: {
      back: "← Back",
      eyebrow: "Gyrotonic®",
      heroTitle: "Three-dimensional movement with a clinical approach.",
      introEyebrow: "Introduction",
      introBody:
        "The Gyrotonic® method is an innovative approach to movement that works the body globally, fluidly and three-dimensionally. Respecting natural biomechanics and the scientific principles of human movement, it promotes complete, balanced work.",
      howEyebrow: "How it works",
      howTitle: "Circular, spiralling and wave-like movements",
      howLead:
        "Grounded in circular, spiralling and wave-like movements, synchronised with breath, Gyrotonic® develops the body in an integrated and efficient way.",
      howSubhead: "This method simultaneously promotes:",
      howItems: [
        "Joint mobility",
        "Deep strength",
        "Coordination",
        "Body awareness",
        "Postural re-education",
      ],
      applicationEyebrow: "Clinical & functional application",
      applicationTitle: "Widely used across different contexts",
      applicationItems: [
        "Physical rehabilitation",
        "Injury prevention",
        "Improved posture",
        "Performance training",
        "Greater mobility and body control",
      ],
      expEyebrow: "Experience & distinction",
      expTitle: "Pioneers in Tavira",
      expBody1:
        "At Yin Motion, we were the first space in Tavira to offer the Gyrotonic® method, integrating it into a clinical, safe and personalised approach.",
      expBody2:
        "Just as with Pilates in 2011, our work contributed to introducing and growing this method across the region.",
      expYearLabel: "First in Tavira",
      expHighlight: "1st",
      supportEyebrow: "Specialist guidance",
      supportTitle: "Physiotherapists with certified training",
      supportBody:
        "Every session is led by physiotherapists with specific certified training, ensuring safety, efficacy and careful adaptation to the needs of each person.",
      goalEyebrow: "Our goal",
      goalTitle: "Freer, more efficient and more mindful movement",
      goalBody:
        "To foster freer, more efficient and more mindful movement, helping every person build a better relationship with their body and improve their quality of life.",
      ctaEyebrow: "Get in touch",
      ctaTitle:
        "Discover a different, complete and fully tailored method.",
      ctaButton: "Get in Touch",
    },
    powerPlatePage: {
      back: "← Back",
      eyebrow: "Power Plate",
      heroTitle: "Neuromuscular stimulation with advanced technology.",
      introEyebrow: "Introduction",
      introBody:
        "Training with Power Plate is based on controlled mechanical vibration, stimulating the neuromuscular system effectively and safely. This technology helps enhance training results, adapting to the needs of each person.",
      howEyebrow: "How it works",
      howTitle: "Controlled vibration, deeper activation",
      howLead:
        "The vibration generated by Power Plate activates the muscles more intensely and deeply, promoting complete work in less time.",
      howSubhead: "This method contributes to:",
      howItems: [
        "Deep muscle activation",
        "Greater strength and endurance",
        "Improved stability and balance",
        "Increased bone density",
        "Optimised training time",
      ],
      applicationEyebrow: "Training & rehabilitation",
      applicationTitle: "Integrated across different contexts",
      applicationItems: [
        "Physical rehabilitation",
        "Functional training",
        "Injury prevention",
        "Muscular recovery",
        "Overall physical conditioning",
      ],
      supportEyebrow: "Specialist guidance",
      supportTitle: "Always led by qualified professionals",
      supportBody:
        "At Yin Motion, Power Plate training is always led by qualified professionals, ensuring safety, efficacy and adaptation to each person’s level.",
      goalEyebrow: "Our goal",
      goalTitle: "Smarter, more efficient and tailored training",
      goalBody:
        "To deliver smarter, more efficient and more tailored training, helping every person progress safely and with consistent results.",
      ctaEyebrow: "Get in touch",
      ctaTitle: "Experience a more effective and guided training approach.",
      ctaButton: "Get in Touch",
    },
    treinoPage: {
      back: "← Back",
      eyebrow: "Personalised Clinical Training",
      heroTitle: "A global approach to movement.",
      introEyebrow: "Introduction",
      introBody1:
        "In personalised clinical training, we are not tied to a single method. We integrate whatever we consider most effective for each case, combining physiotherapy expertise with different techniques and tools.",
      introBody2:
        "Every plan is designed individually, respecting the body, the goals and the context of each person.",
      howEyebrow: "How we work",
      howTitle: "A global view of movement",
      howLead:
        "Our approach is built on a global view of movement, enabling complete, safe and progressive work.",
      howItems: [
        "Improved mobility, posture and balance",
        "Greater strength and endurance",
        "Injury prevention",
        "Functional recovery",
        "Physical performance development",
        "Overall wellbeing",
      ],
      integratedEyebrow: "An integrated approach",
      integratedTitle: "Continuously adapted to your progress",
      integratedBody1:
        "Unlike conventional training, personalised clinical training continuously adapts to the progress of each person.",
      integratedBody2:
        "We integrate different methods and tools, always selecting what makes the most sense for your specific case.",
      supportEyebrow: "Specialist guidance",
      supportTitle: "In-depth knowledge of the body and movement",
      supportLead:
        "Every intervention is guided by in-depth knowledge of the body, movement and rehabilitation processes.",
      supportSubhead: "We ensure support that is:",
      supportItems: ["Safe", "Mindful", "Personalised", "Focused on sustainable results"],
      goalEyebrow: "Our goal",
      goalTitle: "Progress consistently",
      goalBody:
        "To help every person progress consistently, rebuilding confidence in their body and improving their quality of life through movement.",
      ctaEyebrow: "Get in touch",
      ctaTitle: "Start training tailored to you, with professional support.",
      ctaButton: "Get in Touch",
    },
    osteopatiaPage: {
      back: "← Back",
      eyebrow: "Osteopathy",
      heroTitle: "Manual therapy for balance and mobility of the body.",
      introEyebrow: "Introduction",
      introBody:
        "Osteopathy is a manual therapy that addresses musculoskeletal and functional dysfunctions, promoting overall balance of the body.",
      howEyebrow: "How it works",
      howTitle: "Addressing the cause, not just the symptoms",
      howBody:
        "Through specific manual techniques, osteopathy seeks to identify the root cause of the problem, not only its symptoms.",
      benefitsEyebrow: "Benefits",
      benefitsTitle: "Osteopathy contributes to:",
      benefitsItems: [
        "Pain relief",
        "Improved mobility",
        "Bodily balance",
        "Functional recovery",
      ],
      globalEyebrow: "A whole-body approach",
      globalTitle: "The body as a whole",
      globalBody:
        "Treatment is carried out in an integrated way, considering the body as a whole and respecting each person’s individuality.",
      goalEyebrow: "Our goal",
      goalTitle: "Balance, wellbeing and function",
      goalBody:
        "To promote balance within the body, helping every person recover their wellbeing and functionality.",
      ctaEyebrow: "Get in touch",
      ctaTitle: "Restore your body’s balance with specialist support.",
      ctaButton: "Get in Touch",
    },
    medicinaChinesaPage: {
      back: "← Back",
      eyebrow: "Traditional Chinese Medicine",
      heroTitle: "Traditional Chinese Medicine — balance and wellbeing, integrated.",
      introEyebrow: "Introduction",
      introBody:
        "Traditional Chinese Medicine is a therapeutic approach that seeks to restore the body’s balance. It works in an integrated way, considering the body as a whole.",
      howEyebrow: "How it works",
      howTitle: "Time-honoured principles, a whole-body view",
      howBody:
        "Grounded in time-honoured principles combined with a whole-body perspective, it promotes physical and emotional balance.",
      indicationsEyebrow: "Indications",
      indicationsTitle: "This approach is effective in managing:",
      indicationsItems: [
        "Pain",
        "Stress",
        "Fatigue",
        "Functional dysfunctions",
        "Imbalances of the body",
      ],
      complementaryEyebrow: "Complementary approach",
      complementaryTitle: "Complements conventional care",
      complementaryBody:
        "Traditional Chinese Medicine complements conventional care, enhancing results and promoting overall wellbeing.",
      goalEyebrow: "Our goal",
      goalTitle: "Balance of body and mind",
      goalBody:
        "To restore the balance of body and mind, contributing to a better quality of life.",
      ctaEyebrow: "Get in touch",
      ctaTitle: "Discover a complementary approach focused on your wellbeing.",
      ctaButton: "Get in Touch",
    },
    terapiaFalaPage: {
      back: "← Back",
      eyebrow: "Speech Therapy",
      heroTitle: "Speech Therapy — communication, language and function with specialist support.",
      introEyebrow: "Introduction",
      introBody:
        "Speech Therapy focuses on the assessment and treatment of communication, language, speech, voice and swallowing disorders. At Yin Motion, every session is delivered with clinical rigour and tailored to each person.",
      approachEyebrow: "How we work",
      approachTitle: "Individual, rigorous and progressive care",
      approachLead:
        "Intervention is guided individually, respecting the specific needs of each case.",
      approachItems: [
        "Comprehensive and personalised assessment",
        "Intervention tailored to children and adults",
        "Continuous and progressive work",
        "A focus on functional improvement and quality of life",
      ],
      areasEyebrow: "Areas of intervention",
      areasTitle: "Speech Therapy can help with:",
      areasItems: [
        "Speech and language difficulties",
        "Communication disorders",
        "Voice changes",
        "Swallowing difficulties",
        "Development of communication in children",
      ],
      trustEyebrow: "Specialist support",
      trustTitle: "Clinical experience and professional rigour",
      trustBody:
        "Support is delivered with extensive clinical experience and professional rigour, ensuring a safe, structured and effective process.",
      goalEyebrow: "Our goal",
      goalTitle: "Communicate with clarity, confidence and function",
      goalBody:
        "To help every person communicate with more clarity, confidence and function in everyday life.",
      ctaEyebrow: "Get in touch",
      ctaTitle: "Get in touch to start support tailored to your needs.",
      ctaButton: "Get in Touch",
    },
    psicologiaPage: {
      back: "← Back",
      eyebrow: "Psychology",
      heroTitle: "Emotional support with professional and confidential care.",
      introEyebrow: "Introduction",
      introBody:
        "Psychology at Yin Motion is focused on promoting mental health and emotional balance. Every session is delivered with respect, confidentiality and individual attention.",
      howEyebrow: "How we work",
      howTitle: "Adapted to your reality",
      howBody:
        "Psychological support is tailored to the reality of each person, fostering understanding, balance and personal development.",
      areasEyebrow: "Areas of support",
      areasTitle: "Psychology can help with:",
      areasItems: [
        "Anxiety and stress",
        "Emotional regulation",
        "Chronic pain",
        "Adapting to different life stages",
        "Personal development",
      ],
      trustEyebrow: "Confidentiality & trust",
      trustTitle: "A safe space, just for you",
      trustBody:
        "We provide a safe space where every person can express themselves freely, with complete respect and professionalism.",
      goalEyebrow: "Our goal",
      goalTitle: "Emotional balance, clarity and wellbeing",
      goalBody:
        "To help every person find emotional balance, clarity and wellbeing in their daily life.",
      ctaEyebrow: "Get in touch",
      ctaTitle: "Take the first step towards caring for your mental health.",
      ctaButton: "Get in Touch",
    },
  },
};

const LanguageContext = createContext({
  lang: "pt",
  setLang: () => {},
  t: (k) => k,
});

const getByPath = (obj, path) => {
  return path.split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), obj);
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "pt";
    const saved = window.localStorage.getItem(LANG_KEY);
    return saved === "en" ? "en" : "pt";
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(LANG_KEY, lang);
      document.documentElement.setAttribute(
        "lang",
        lang === "en" ? "en-GB" : "pt-PT"
      );
    } catch (e) {}
  }, [lang]);

  const setLang = (l) => setLangState(l === "en" ? "en" : "pt");

  const value = useMemo(() => {
    const t = (path, vars) => {
      const raw = getByPath(dict[lang], path);
      if (raw == null) {
        // fallback to PT so nothing ever breaks
        const fb = getByPath(dict.pt, path);
        return fb == null ? path : fb;
      }
      if (typeof raw === "string" && vars) {
        return Object.entries(vars).reduce(
          (acc, [k, v]) => acc.replaceAll(`{{${k}}}`, String(v)),
          raw
        );
      }
      return raw;
    };
    return { lang, setLang, t };
  }, [lang]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useT = () => useContext(LanguageContext);
